import { useEffect } from 'react'
import { SITE_STATUS_DRAFT_ID } from 'constants/siteStatuses'

/**
 * Boundary load + `postDraftSiteGeometry` belong on the Map tab (`mapPage.js`).
 * For draft sites, About/Details used to call `utils/addGraphicsToKBALayer` (which POSTs),
 * duplicating work and racing tab switches with sketch saves — e.g. overwriting a merged
 * draft with a single-geometry refetch.
 *
 * @param {object} site           - site object from SiteContext
 * @param {object} params         - route params from useParams()
 * @param {string|number} historyId - resolved history ID for this site context
 * @param {boolean} isReassessment  - whether the current flow is a reassessment
 */
export function useBoundaryGeometry({ site, params, historyId, isReassessment = false }) {
  useEffect(() => {
    if (!site.id) return
    if (site.SiteStatusId === SITE_STATUS_DRAFT_ID) return
  }, [params.id, historyId, site.id, site.SiteStatusId, isReassessment])
}
